import { createRouter, createWebHistory } from "vue-router";
import store from "@/store/index";
import { ElMessage } from "element-plus";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home/index.vue"),
  },
  {
    path: "/movies-list",
    name: "movies-list",
    component: () => import("@/views/Movie/movies-list.vue"),
  },
  {
    path: "/movies-item",
    name: "movies-item",
    component: () => import("@/views/Movie/movies-item.vue"),
  },
  {
    path: "/coins-recharge",
    name: "coins-recharge",
    component: () => import("@/views/Account/coins-recharge.vue"),
  },
  {
    path: "/vip-purchase",
    name: "vip-purchase",
    component: () => import("@/views/Account/vip-purchase.vue"),
  },
  {
    path: "/order-list",
    name: "order-list",
    component: () => import("@/views/Account/order-list.vue"),
  },
  {
    path: "/terms-conditions",
    name: "terms-conditions",
    component: () => import("@/views/Account/terms-conditions.vue"),
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () => import("@/views/Account/privacy-policy.vue"),
  },
  {
    path: "/recurring-payment-authorization",
    name: "recurring-payment-authorization",
    component: () => import("@/views/Account/recurring-payment-authorization.vue"),
  },
  {
    path: "/email-sample",
    name: "email-sample",
    component: () => import("@/views/Account/email-sample.vue"),
  },
  {
    path: "/cancel-subscription",
    name: "cancel-subscription",
    component: () => import("@/views/Account/cancel-subscription.vue"),
  },
  {
    path: "/refund-policy",
    name: "refund-policy",
    component: () => import("@/views/Account/refund-policy.vue"),
  },
  {
    path: "/cookie-policy",
    name: "cookie-policy",
    component: () => import("@/views/Account/cookie-policy.vue"),
  },
  {
    path: "/dmca-policy",
    name: "dmca-policy",
    component: () => import("@/views/Account/dmca-policy.vue"),
  },
  {
    path: "/contact-us",
    name: "contact-us",
    component: () => import("@/views/Account/contact-us.vue"),
  },
  // 404 页面
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("@/views/404.vue"),
  },
  {
    path: '/checkoutnow',
    name: 'checkoutnow',
    component: () => import('@/views/paypal.vue')
  },
  {
    path: '/webapps/billing/subscriptions',
    name: 'subscriptions',
    component: () => import('@/views/paypal-subscription.vue')
  },
  {
    // 路由重定向
    path: "/",
    redirect: {
      path: "/home",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // 每次路由跳转之后 新页面加载在x轴和y轴的初始位置
  scrollBehavior() {
    return {
      left: 0,
      top: 0,
    };
  },
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  next();
});

export default router;
